import FullReportContainer from './full_reports_container';

const FullReport = FullReportContainer;
export default FullReport;
